var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5H10.625V3.75C10.625 2.025 9.225 0.625 7.5 0.625C5.775 0.625 4.375 2.025 4.375 3.75V5H3.75C3.0625 5 2.5 5.5625 2.5 6.25V12.5C2.5 13.1875 3.0625 13.75 3.75 13.75H11.25C11.9375 13.75 12.5 13.1875 12.5 12.5V6.25C12.5 5.5625 11.9375 5 11.25 5ZM7.5 10.625C6.8125 10.625 6.25 10.0625 6.25 9.375C6.25 8.6875 6.8125 8.125 7.5 8.125C8.1875 8.125 8.75 8.6875 8.75 9.375C8.75 10.0625 8.1875 10.625 7.5 10.625ZM5.625 5V3.75C5.625 2.7125 6.4625 1.875 7.5 1.875C8.5375 1.875 9.375 2.7125 9.375 3.75V5H5.625Z",
    fill: "#FF3E5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4846ffee385933b9eee8ce5e4ef6e410.svg";
export { ForwardRef as ReactComponent };